import { BarChartState } from "./barchart.types";
import {
  BarChartActionTypes,
  LOAD_BARCHART,
  LOAD_BARCHART_FAILURE,
  LOAD_BARCHART_SUCCESS,
} from "./barchart.types";

export const initialBarChartState: BarChartState = {
  isLoading: false,
  success: false,
  error: null,
  data: [],
  period: null,
  profile: "",
};

export function barChartReducer(
  state = initialBarChartState,
  action: BarChartActionTypes
) {
  const { period, profile } = action.payload;

  switch (action.type) {
    case LOAD_BARCHART:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
        period,
        profile,
      };
    case LOAD_BARCHART_SUCCESS: {
      if (state.period === period && state.profile === profile) {
        return {
          ...state,
          isLoading: false,
          success: true,
          error: null,
          data: action.payload.data,
        };
      } else {
        return state;
      }
    }
    case LOAD_BARCHART_FAILURE:
      if (state.period === period && state.profile === profile) {
        return {
          ...state,
          isLoading: false,
          success: false,
          error: action.payload.error,
          data: [],
        };
      } else {
        return state;
      }
    default:
      return state;
  }
}
